import { inject, observer } from 'mobx-react';
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { 
  Calendar, Trash, Facebook, Instagram, Linkedin, Plus, 
  Share2, Twitter, Youtube, Eye, Users, UserPlus, Edit 
} from "react-feather";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row, Modal } from "reactstrap";
import profileImg from "../../assets/img/profile/placeholder.svg";
import "../../assets/scss/pages/users.scss";
import "../../assets/scss/pages/common.scss";
import Avatar from "./components/AvatarComponent";
import ICustomer from "../../types/ICustomer";
import classnames from "classnames";
import ScheduleMeetingWizard from "../calendar/components/ScheduleMeetingWizard";
import PerfectScrollbar from "react-perfect-scrollbar";
import ContentSelector from "../elements/contentSelector";
import CustomerActivities from '../common/elements/customerActivity';
import CalendarApp from '../calendar/Calendar';
import { history } from "../../history";
import CustomerStore from '../../stores/customerStore';

interface ICustomerViewProps {
  customer: ICustomer,
  customerStore: CustomerStore,
  sessionStore: any,
  match: any
  createMeetingStore: any
}

interface ICustomerViewState {
  showModal: boolean,
  meetingSliderVisibility: boolean
}


let Customer_Activity = [
  {
    action: "visited",
    content: {
      id: "",
      title: "How to choose best plan for your kid"
    },
    duration: "30 sec",
    actionTaken: "20 min ago"
  },
  {
    action: "visited",
    content: {
      id: "",
      title: "Youtube Design"
    },
    duration: "3 mins",
    actionTaken: "30 min ago"
  },
  {
    action: "shared",
    content: {
      id: "",
      title: "Youtube Design"
    },
    serviceUsed: "Whatsapp",
    actionTaken: "2 days ago"
  },
  {
    action: "attended",
    content: {
      id: "",
      title: "How to choose best plan for your kid"
    },
    duration: "14 mins",
    actionTaken: "2 days ago"
  },
  {
    action: "shared",
    content: {
      id: "",
      title: "How to choose best plan for your kid"
    },
    serviceUsed: "Email and SMS",
    actionTaken: "2 days ago"
  },
  {
    action: "attended",
    content: {
      id: "",
      title: "How to choose best plan for your kid"
    },
    duration: "14 mins",
    actionTaken: "2 days ago"
  },
  {
    action: "invited",
    content: {
      id: "",
      title: "Economy Management"
    },
    eventOn: "23-June-2020",
    eventAt: "6pm",
    actionTaken: "2 days ago"
  },
  {
    action: "invited",
    content: {
      id: "",
      title: "Best Innovation Ideas"
    },
    eventOn: "24-June-2020",
    eventAt: "3pm",
    actionTaken: "2 days ago"
  }
]


const ICONS: any = {
  shared: <Share2 size={16} />,
  visited: <Eye size={16} />,
  invited: <UserPlus size={16} />,
  attended: <Users size={16} />,
}

@inject('customerStore', 'sessionStore', 'createMeetingStore')
@observer
class CustomerView extends React.Component<ICustomerViewProps, ICustomerViewState> {

  state = {
    showModal: false,
    meetingSliderVisibility: false
  }
  componentDidMount(){
    const { match, sessionStore } = this.props;
    sessionStore.setContentSharing("customer");
    if(match.params.id){
      let { customerStore } = this.props;
      customerStore.loadCustomer(match.params.id);
    }
  }

  toggleModal = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }))
  }
  
  toggleMeetingSlider = () => {
    this.setState(prevState => ({
      meetingSliderVisibility: !prevState.meetingSliderVisibility
    }))
  }

  deleteCustomer = (uid?: string) => {
    let { customerStore } = this.props;
    var result = confirm("Are you sure you want to delete?");
    if (result && uid != undefined) {
      customerStore.deleteCustomer(uid);
      history.goBack();//TODO: navigate back to customer list page
    }
    return;
  }

  onCreateSuccess = () => {
    this.setState({ meetingSliderVisibility: false });
  }

  getColor = (action: string) => {
    switch(action) {
      case "visited": 
        return "green";
      case "shared":
        return "#FFDF00";
      case "attended":
        return "red"; 
      case "invited":
        return "#7769f7";
      default: 
        return "#eee"
    }
  }

  visitText = (item:any) => {
    return(
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{item.action}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{item.content.title}</u></span> for&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{item.duration}</span>
      </p>
    )
  }

  shareText = (item: any) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{item.action}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{item.content.title}</u></span> via&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{item.serviceUsed}</span>
      </p>
    )
  }

  attendedText = (item: any) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{item.action}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{item.content.title}</u></span> for&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{item.duration}</span>
      </p>
    )
  }

  inviteText = (item: any) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{item.action}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{item.content.title}</u></span> on&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{item.eventOn}, {item.eventAt}</span>
      </p>
    )
  }

  getActivityInfo = (item: any) => {
    const {action} = item;
    switch (action) {
      case "visited":
        return this.visitText(item);
      case "shared":
        return this.shareText(item);
      case "attended":
        return this.attendedText(item);
      case "invited":
        return this.inviteText(item);
      default:
        return "--NA--";
    }
  }

  render() {
    const { customer, customerActivities } = this.props.customerStore; 
    const { activities } = customerActivities   

    const modal = (<Modal
      isOpen={this.state.showModal}
      toggle={this.toggleModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <h3 className="heading">Select Content</h3>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <ContentSelector
          contentSharing="customer"
          toggle={this.toggleModal}
        />
      </div>
    </Modal>)

    return (
      <Fragment>
        <Row>
          <Col sm="12" md="6">
            <Card>
              <CardBody>
                <div className="profile-header mb-2 align-center">
                  <div className="profile-img-container align-center mb-2">
                    <img
                      src={customer.account.image ? customer.account.image : profileImg }
                      alt="porfileImg"
                      className="img-fluid img-border rounded-circle box-shadow-1 height-150"
                    />                    
                  </div>
                  <h4>
                    {customer.account.title+" "+customer.account.firstName+" "+customer.account.lastName}
                  </h4>
                  <h5>
                   {customer.account.jobTitle ? customer.account.jobTitle+", ": ""}
                   {customer.account.departmentName ? customer.account.departmentName+", ": ""}
                   {customer.account.company}
                  </h5>
                </div>
                <hr />
                <CardHeader>
                  <CardTitle className="ml-19">Contact Details</CardTitle>
                </CardHeader>

                <div className="users-page-view-table">
                  <div className="d-flex user-info">
                    <div className="user-info-title font-weight-bold">
                      Mobile
                    </div>
                    <div>{customer.account.phoneNumber ? "Please update the number!" : customer.account.phoneNumber }</div>
                  </div>
                </div>
                <div className="users-page-view-table">
                  <div className="d-flex user-info">
                    <div className="user-info-title font-weight-bold">
                      Email
                    </div>
                    <div>{customer.account.email == "" ? "Please update the number!" : customer.account.email}</div>
                  </div>
                </div>
                <div className="users-page-view-table">
                  <div className="d-flex user-info">
                    <div className="user-info-title font-weight-bold">
                      Location
                    </div>
                    <div>
                      {customer.address.state == "" ? "" : customer.address.state + ", "}
                      {customer.address.country == "" ? "" : customer.address.country}
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <a 
                    className={customer.social.facebook ? "" : "disabled"}
                    target="_blank" 
                    href={customer.social.facebook == "" ? "#": customer.social.facebook}>
                    <Avatar className="mr-1" color={customer.social.facebook ? "primary": "#"} icon={<Facebook />} />
                  </a>
                  <a 
                    className={customer.social.youtube ? "" : "disabled"}
                    target="_blank" 
                    href={customer.social.youtube == "" ? "#": customer.social.youtube}>
                    <Avatar className="mr-1" color={customer.social.youtube ? "danger": "#"} icon={<Youtube />} />
                  </a>
                  <a 
                    className={customer.social.twitter ? "" : "disabled"}
                    target="_blank" 
                    href={customer.social.twitter == "" ? "#": customer.social.twitter}>
                    <Avatar className="mr-1" color={customer.social.twitter ? "info": "#"} icon={<Twitter />} />
                  </a>
                  <a
                    className={customer.social.instagram ? "" : "disabled"} 
                    target="_blank"
                    href={customer.social.instagram == "" ? "#": customer.social.instagram}>
                    <Avatar className="mr-1" color={customer.social.instagram ? "warning": "#"} icon={<Instagram />} />
                  </a>
                  <a 
                    className={customer.social.linkedin ? "" : "disabled"}
                    target="_blank" 
                    href={customer.social.linkedin == "" ? "#": customer.social.linkedin}>
                    <Avatar className="mr-1" color={customer.social.linkedin ? "primary": "#"} icon={<Linkedin />} />
                  </a>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Additional Information</CardTitle>
              </CardHeader>
              <CardBody>
                <p className="mb-0">{customer.account.additionalInfo == ""
                  ? <i className="text-muted">No Additional Information Provided</i> 
                  : customer.account.additionalInfo}
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col sm="12" md="6">
            <Card>
              <div className="d-flex justify-content-between align-items-center d-wrap p-2">
                <div>
                  <Button 
                  color="primary" 
                  onClick={this.toggleMeetingSlider} 
                  className="d-sm-block d-none display-inline mr-1 mb-0">
                    <Calendar size={13} /> 
                    <span className="align-middle">{" "}Schedule</span>
                  </Button>
                  <Button 
                    color="primary" 
                    onClick={this.toggleModal} 
                    className="d-sm-block d-none display-inline mr-1 mb-0">
                    <Share2 size={13} /> 
                    <span className="align-middle">{" "} Share</span>
                  </Button>
                </div>
                <div>
                  <Link to={`/customer/edit/${customer.uid}`}>
                    <Button
                      color="warning"
                      onClick={this.toggleModal}
                      className="d-sm-block d-none display-inline mr-1 mb-0">
                      <Edit size={13} />
                      <span className="align-middle">{" "} Edit</span>
                    </Button>
                  </Link>
                  <Button
                    color="danger"
                    onClick={()=>this.deleteCustomer(customer.uid)}
                    className="d-sm-block d-none display-inline mb-0">
                    <Trash size={13} />
                    <span className="align-middle">{" "} Delete</span>
                  </Button>
                  
                </div>
                
              </div>
              <hr />
              <CardHeader>
                <CardTitle>Activity Timeline</CardTitle>
              </CardHeader>
              <CardBody>
                <CustomerActivities activities={activities}/>
              </CardBody>
            </Card>
          </Col>
        </Row> 
        { modal }
        <div className="animation-slider">
          {
            this.state.meetingSliderVisibility
              ? <ScheduleMeetingWizard
                  show={this.state.meetingSliderVisibility}
                  onCreateSuccess={this.onCreateSuccess}
                  toggleSliderVisibility={this.toggleMeetingSlider}
                  createMeetingStore={this.props.createMeetingStore}
                  sessionStore={this.props.sessionStore}
                  meetingId=""
                  customer={customer}
                />
              : null
          }
          <div
            className={classnames("animation-slider-overlay", {
              show: this.state.meetingSliderVisibility
            })}
            onClick={() => this.toggleMeetingSlider()}
          />
        </div> 
      </Fragment>
    )
  }
}

export default CustomerView;